import * as bd from 'react-basic-design';
import { T } from '../../../components/basic/text';

export function calculateContractPeriod(startDate?: Date | string, endDate?: Date | string) {
    if (!endDate || !startDate) return <T>invalid-values</T>;

    startDate = new Date(startDate.toString());
    endDate = new Date(endDate.toString());

    if (endDate < startDate) {
        return <T className="text-danger">invalid-contract-period</T>;
    }

    let years = endDate.getFullYear() - startDate.getFullYear();
    let months = endDate.getMonth() - startDate.getMonth();
    let days = endDate.getDate() - startDate.getDate();

    if (days < 0) {
        const lastDayOfMonth = new Date(endDate.getFullYear(), endDate.getMonth(), 0).getDate();
        days += lastDayOfMonth;
        months--;
    }

    if (months < 0) {
        months += 12;
        years--;
    }

    const parts = [];

    if (years > 0) parts.push(<T value={years}>@value-years</T>);
    if (months > 0) parts.push(<T value={months}>@value-months</T>);
    if (days > 0) parts.push(<T value={days}>@value-days</T>);

    if (parts.length === 0) {
        return <T className="text-warning">zero-day</T>;
    }

    return (
        <bd.Flex align="center" gap={1}>
            {parts.map((part, index) => {
                return (
                    <>
                        {part}
                        {index < parts.length - 1 && <T>and</T>}
                    </>
                );
            })}
        </bd.Flex>
    );
}
export function calculateRemainingTime(endDate?: Date | string, now?: Date | string) {
    if (!now || !endDate) return <T>invalid-values</T>;

    endDate = new Date(endDate.toString());
    now = new Date(now.toString());

    if (now < endDate) {
        return <T className="text-danger">expired-contract</T>;
    }

    let years = now.getFullYear() - endDate.getFullYear();
    let months = now.getMonth() - endDate.getMonth();
    let days = now.getDate() - endDate.getDate();

    if (days < 0) {
        const lastDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 0).getDate();
        days += lastDayOfMonth;
        months--;
    }

    if (months < 0) {
        months += 12;
        years--;
    }

    const parts = [];

    if (years > 0) parts.push(<T value={years}>@value-years</T>);
    if (months > 0) parts.push(<T value={months}>@value-months</T>);
    if (days > 0) parts.push(<T value={days}>@value-days</T>);

    if (parts.length === 0) {
        return <T className="text-warning">zero-day</T>;
    }

    return (
        <bd.Flex align="center" gap={1}>
            {parts.map((part, index) => {
                return (
                    <>
                        {part}
                        {index < parts.length - 1 && <T>and</T>}
                    </>
                );
            })}
        </bd.Flex>
    );
}
